/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconArrowBadgeDown = createReactComponent("arrow-badge-down", "IconArrowBadgeDown", [
  ["path", { d: "M17 13v-6l-5 4l-5 -4v6l5 4z", key: "svg-0" }]
]);

export { IconArrowBadgeDown as default };
//# sourceMappingURL=IconArrowBadgeDown.js.map
